export enum ReceptionStatus {
    CHECK = 'CHECK',              // 중요체크
    RECEIVED = 'RECEIVED',        // 접수중
    INBOUND_SCHEDULED = 'INBOUND_SCHEDULED', // 입고예정
    OUTBOUND_READY = 'OUTBOUND_READY',       // 출고대기
    TRIP_READY = 'TRIP_READY',               // 출장대기
    REPAIRING = 'REPAIRING',      // 수리중
    ARREARS = 'ARREARS',          // 미수
    PAID = 'PAID',                // 결제완료 (선택)
    DONE = 'DONE',                // 완료
    CONSULTED = 'CONSULTED',      // 상담완료 (참고 HTML에 존재)
}

export enum ReceptionType {
    GENERAL = 'GENERAL',          // 일반
    EXCHANGE = 'EXCHANGE',        // 맞교환
    TRIP = 'TRIP',                // 출장
    COMP_SALE = 'COMP_SALE',      // 보상판매
    VISIT = 'VISIT',              // 방문
    SALE = 'SALE',                // 판매
    REPAIR_COMP = 'REPAIR_COMP', // 리퍼보상
    NEW_EXCHANGE = 'NEW_EXCHANGE', //신상맞교환
    // COMP_SALE_TRIP = 'COMP_SALE_TRIP', // 보상판매출장
}

export enum InboundMethod {
    COURIER = 'COURIER',          // 택배
    TRIP = 'TRIP',                // 출장
    VISIT = 'VISIT',              // 방문
}

// HTML: `입고/택발` 개념(입고, 택발)을 모델링
export enum FlowType {
    INBOUND = 'INBOUND',          // 입고
    OUTBOUND_COURIER = 'OUTBOUND_COURIER',  // 택발(택배발송)
}

export enum PaymentMethod {
    BANK = 'BANK',                // 계좌이체
    CARD = 'CARD',                // 카드
    CASH = 'CASH',                // 현금
    FREE = 'FREE',                // 무상
    ARREARS = 'ARREARS',          // 미수
    OTHER = 'OTHER',              // 기타
}

export enum ProofType {
    CASH_RECEIPT = 'CASH_RECEIPT',  // 현금영수증
    RECEIPT = 'RECEIPT',            // 영수발행
    INVOICE = 'INVOICE',            // 청구발행
    BUSINESS = 'BUSINESS',          // 사업자증빙
    NONE = 'NONE',                  // 미발행
    NARABIL = 'NARABIL',
}

export enum ReceptionItemKind {
    BOILER = 'BOILER',            // 보일러/수리행
    SALE = 'SALE',                // 판매행
    DISCOUNT = 'DISCOUNT',        // 할인행
}

export enum DateType {
    RECEIVED = 'RECEIVED',    // 접수일
    INBOUND = 'INBOUND',      // 입고일
    REPAIR = 'REPAIR',        // 수리일
    OUTBOUND = 'OUTBOUND',    // 출고일
    ESTIMATE = 'ESTIMATE',    // 견적일
    TRIP = 'TRIP',            // 출장일
}

export function getDateType() {
    return [
        { label: '접수일', value: 'RECEIVED' },
        { label: '견적일', value: 'ESTIMATE' },
        { label: '수리일', value: 'REPAIR' },
        { label: '입고일', value: 'INBOUND' },
        { label: '출고일', value: 'OUTBOUND' },
        { label: '출장일', value: 'TRIP' },
    ];
}

export function getReceptionStatus() {
    return [
        { label: '중요체크', value: 'CHECK' },
        { label: '접수중', value: 'RECEIVED' },
        { label: '입고예정', value: 'INBOUND_SCHEDULED' },
        { label: '출고대기', value: 'OUTBOUND_READY' },
        { label: '출장대기', value: 'TRIP_READY' },
        { label: '수리중', value: 'REPAIRING' },
        { label: '미수', value: 'ARREARS' },
        { label: '결제완료', value: 'PAID' },
        { label: '완료', value: 'DONE' },
        { label: '상담완료', value: 'CONSULTED' },
    ];
}

export function getReceptionType() {
    return [
        { label: '일반', value: 'GENERAL' },
        { label: '맞교환', value: 'EXCHANGE' },
        { label: '출장', value: 'TRIP' },
        { label: '보상판매', value: 'COMP_SALE' },
        { label: '방문', value: 'VISIT' },
        { label: '판매', value: 'SALE' },
        { label: '리퍼보상', value: 'REPAIR_COMP' },
        { label: '신상맞교환', value: 'NEW_EXCHANGE' },
        // { label: '보상판매출장', value: 'COMP_SALE_TRIP' }
    ];
}

export function getInboundMethod() {
    return [
        { label: '택배', value: 'COURIER' },
        { label: '출장', value: 'TRIP' },
        { label: '방문', value: 'VISIT' },
    ];
}

export function getFlowType() {
    return [
        { label: '입고', value: 'INBOUND' },
        { label: '택발', value: 'OUTBOUND_COURIER' },
    ];
}

export function getPaymentMethod() {
    return [
        { label: '계좌이체', value: 'BANK' },
        { label: '카드', value: 'CARD' },
        { label: '현금', value: 'CASH' },
        // { label: '무상', value: 'FREE' },
        { label: '미수', value: 'ARREARS' },
        { label: '기타', value: 'OTHER' },
    ];
}

export function getProofType() {
    return [
        { label: '현금영수증', value: 'CASH_RECEIPT' },
        { label: '영수발행', value: 'RECEIPT' },
        { label: '청구발행', value: 'INVOICE' },
        { label: '사업자증빙', value: 'BUSINESS' },
        { label: '미발행', value: 'NONE' },
    ];
}

export function getReceptionItemKind() {
    return [
        { label: '보일러/수리행', value: 'BOILER' },
        { label: '판매행', value: 'SALE' },
    ];
}